import React from 'react';
import { getClonedChild, Group, useBreakpoint } from '@landr/maestro';
import styled from 'styled-components';
import TypesFilter from './components/TypesFilter/TypesFilter';
import SearchBar from './components/SearchBar/SearchBar';
import SearchBarProvider from './context/SearchBarContext/SearchBarContext';
import { Suggestions } from './context/SearchBarContext/types';
import AdvancedFiltersToggle from './components/AdvancedFiltersToggle/AdvancedFiltersToggle';

interface SubComponents {
    Types: typeof TypesFilter;
    SearchBar: typeof SearchBar;
}

export const FiltersAndSearchWrapper = styled(Group)`
    justify-content: space-between;
    align-items: center;

    ${({ theme }) => theme.breakpoint('lg')`
        align-items: initial;
    `}
`;

const Filters: React.FC<{
    defaultPlaceholder?: string;
    trending?: Suggestions[];
    withAdvancedFilters?: boolean;
    onSidebarOpen?: () => void;
    showOnlyFilterSuggestions?: boolean;
}> &
    SubComponents = ({
    children,
    defaultPlaceholder,
    trending,
    withAdvancedFilters = true,
    onSidebarOpen,
    showOnlyFilterSuggestions = true,
}) => {
    const childrenArray = React.Children.toArray(children);
    const showSearchOnTop = useBreakpoint('md');

    const typesFilter = getClonedChild(childrenArray, 'Filters.Types');
    const searchBar = getClonedChild(childrenArray, 'Filters.SearchBar');

    return (
        <SearchBarProvider
            trending={trending}
            defaultPlaceholder={defaultPlaceholder}
            showOnlyFilterSuggestions={showOnlyFilterSuggestions}
        >
            <Group
                direction={showSearchOnTop ? 'vertical' : 'horizontal'}
                maxWidth="100%"
                marginBottom="24px"
                gutter="xs"
            >
                <Group.Item>{searchBar}</Group.Item>
                <Group.Item flexGrow={10}>
                    <Group gutter="xs">
                        <Group.Item>{typesFilter}</Group.Item>
                        {withAdvancedFilters && (
                            <Group.Item
                                flexGrow={10}
                                textAlign={
                                    showSearchOnTop ? 'inherit' : 'right'
                                }
                            >
                                <AdvancedFiltersToggle
                                    onSidebarOpen={onSidebarOpen}
                                />
                            </Group.Item>
                        )}
                    </Group>
                </Group.Item>
            </Group>
        </SearchBarProvider>
    );
};

Filters.Types = TypesFilter;
Filters.SearchBar = SearchBar;

export default Filters;
